// extracted by mini-css-extract-plugin
export default {"div":"WorkWithUs_div__YWP6Z"};